import get from 'lodash/get';
import 'rxjs/add/operator/combineLatest';
import {stateGoBack} from '../../../app/actions';
import {getCollection} from '../../../core-utilities/domain/ReduxUtils';
import {buildTaskPropsByType} from '../../redux/utils';


export const TaskViewTimerLogContainer = (config) => (state$, dispatch) => (props$) => {
  const {
    taskType,
    taskListState,
  } = config;

  const onGoBack = () => dispatch(stateGoBack({state: taskListState}));
  const {
    stateParams$,
    task$,
    breadcrumbPath$,
  } = buildTaskPropsByType(taskType, state$, props$);

  return props$
    .combineLatest(
      stateParams$,
      task$,
      breadcrumbPath$,
      (props, stateParams, task, breadcrumbPath) => ({
        ...props,
        taskType,
        // init: !!task,
        parentId: get(stateParams, 'taskId'),
        collection: getCollection(task),
        task,
        breadcrumbPath,
        onGoBack,
      }));
};



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewTimerLog/TaskViewTimerLogContainer.js